import React from 'react';
import { HolographicButton } from './HolographicButton';
import { useCountdown } from '../hooks/useCountdown';
export function FinalUrgency() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const CHECKOUT_URL = 'https://emalia.lat/cart/48340125352186:1';
  return <section className="py-16 bg-secondary text-white text-center" data-id="element-41">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-43">
          Tienes 14 días para cambiar tu relación con el azúcar… empieza hoy
        </h2>

        <div className="inline-block bg-white/10 rounded-lg px-6 py-3 mb-8 backdrop-blur-sm border border-white/20" data-id="element-44">
          <p className="text-accent-coral font-bold text-lg mb-1" data-id="element-45">
            LA OFERTA EXPIRA EN:
          </p>
          <div className="text-4xl font-mono font-bold tracking-widest" data-id="element-46">
            00:{minutes < 10 ? `0${minutes}` : minutes}:
            {seconds < 10 ? `0${seconds}` : seconds}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left max-w-2xl mx-auto mb-10 text-gray-300" data-id="element-47">
          <div className="flex items-center gap-2" data-id="element-48">
            <div className="w-2 h-2 bg-primary rounded-full" data-id="element-49"></div>
            <span data-id="element-50">Sin dietas extremas</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-51">
            <div className="w-2 h-2 bg-primary rounded-full" data-id="element-52"></div>
            <span data-id="element-53">Sin pasar hambre</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-54">
            <div className="w-2 h-2 bg-primary rounded-full" data-id="element-55"></div>
            <span data-id="element-56">Resultados en 14 días</span>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-57">
          <HolographicButton href={CHECKOUT_URL} className="w-full md:w-auto min-w-[300px] shadow-2xl shadow-primary/20" firePixelEvent={true} data-id="element-58">
            Comprar ahora por $29.999 COP
          </HolographicButton>

          <p className="text-sm text-gray-400" data-id="element-59">
            Entrega inmediata por email • Garantía 7 días • Pago seguro
          </p>
        </div>
      </div>
    </section>;
}